export default __webpack_public_path__ + "static/media/pause_icon.214b34f4.svg";